import apiClient from './client'
import type { Comment } from '../types'

export const commentsApi = {
  /** Fetch approved top-level comments + replies for a post. */
  async getBySlug(slug: string): Promise<Comment[]> {
    const res = await apiClient.get<{ data: Comment[] }>(`/api/posts/${slug}/comments`)
    return res.data.data
  },

  /** Post a new comment (requires auth). */
  async create(
    slug: string,
    body: string,
    parentCommentId?: string,
  ): Promise<Comment> {
    const res = await apiClient.post<{ data: Comment }>(
      `/api/posts/${slug}/comments`,
      { body, parentCommentId: parentCommentId ?? null },
    )
    return res.data.data
  },

  /** Like a comment (rate-limited server-side). */
  async like(commentId: string): Promise<void> {
    await apiClient.put(`/api/comments/${commentId}/like`)
  },

  /** Soft-delete a comment (requires auth, must be author or admin). */
  async delete(commentId: string): Promise<void> {
    await apiClient.delete(`/api/comments/${commentId}`)
  },
}
